$shm_hitalama_page $mol_page
	resize_side \right
	width_min 200
	width_max 1024
	style *
		^
		width <= width_px
		flexBasis <= width_px
	sub /
		^
		<= Side_resizer $shm_hitalama_resizer_side
			resize_side <= resize_side
			width_min <= width_min
			width_max <= width_max
			width_px => width_px
